import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/newsfeed/ArticleSearch/ArticleSearchSkeleton/articleSearchSkeleton.consts';

export const AuthorDataSkeleton = () => (
  <ContentLoader height={40} viewBox="0 0 150 40" {...DEFAULT_SETTINGS}>
    <circle cx="16" cy="16" r="16" />
    <rect x="42" y="5" rx="0" ry="0" width="50" height="10" />
    <rect x="42" y="17" rx="0" ry="0" width="70" height="10" />
  </ContentLoader>
);
